"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initReportObservable = exports.RawReportType = void 0;
var error_1 = require("../../tools/error");
var observable_1 = require("../../tools/observable");
var utils_1 = require("../../tools/utils");
var internalMonitoring_1 = require("../internalMonitoring");
exports.RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(apis) {
    var observables = [];
    if ((0, utils_1.includes)(apis, exports.RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable());
    }
    var reportTypes = apis.filter(function (api) { return api !== exports.RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return observable_1.mergeObservables.apply(void 0, observables);
}
exports.initReportObservable = initReportObservable;
function createReportObservable(reportTypes) {
    var observable = new observable_1.Observable(function () {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = (0, internalMonitoring_1.monitor)(function (reports) {
            return reports.forEach(function (report) {
                observable.notify(buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
    return observable;
}
function createCspViolationReportObservable() {
    var observable = new observable_1.Observable(function () {
        var handleCspViolation = (0, internalMonitoring_1.monitor)(function (event) {
            observable.notify(buildRawReportFromCspViolation(event));
        });
        var stop = (0, utils_1.addEventListener)(document, "securitypolicyviolation" /* SECURITY_POLICY_VIOLATION */, handleCspViolation).stop;
        return stop;
    });
    return observable;
}
function buildRawReportFromReport(_a) {
    var type = _a.type, body = _a.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function buildRawReportFromCspViolation(event) {
    var type = exports.RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: exports.RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: buildStack(event.effectiveDirective, "".concat(message, " of the policy \"").concat((0, utils_1.safeTruncate)(event.originalPolicy, 100, '...'), "\""), event.sourceFile, event.lineNumber, event.columnNumber),
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return (sourceFile &&
        (0, error_1.toStackTraceString)({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber,
                    column: columnNumber,
                },
            ],
        }));
}
//# sourceMappingURL=reportObservable.js.map